/**
 * @fileoverview GET handler for the "/engagement/landing_page_templates_data/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLandingPageTemplatesDataId } from "./constants";
import type { EngagementLandingPageTemplatesDataIdResult } from "./types";
import { isEngagementLandingPageTemplatesDataIdResult } from "./validators";

export const getEngagementLandingPageTemplatesDataId = reactQueryFetcherAdapter(
  engagementLandingPageTemplatesDataId,
  (signal: AbortSignal, landingPageId: string): Promise<EngagementLandingPageTemplatesDataIdResult> => {
    return fetch(`/engagement/landing_page_templates_data/${landingPageId}`, "GET", {}, { signal });
  },
  isEngagementLandingPageTemplatesDataIdResult
);
